import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type GlobalState = {
  currentGlobalTime: number;
};

const initialState: GlobalState = {
  currentGlobalTime: 0,
};

export const globalStateSlice = createSlice({
  name: "globalState",
  initialState,
  reducers: {
    setGlobalCurrentTime: (state, action: PayloadAction<number>) => {
      state.currentGlobalTime = action.payload;
    },
  },
});

export const { setGlobalCurrentTime } = globalStateSlice.actions;

export default globalStateSlice.reducer;
